import { FC } from "react";

import { Link } from "../../../../../utils/routing";
import { pageUrl } from "../../../../../utils/urls";
import { MappedAllAssessmentTableRow, getAssessmentStatusLabel } from "../utils";

import { AssessmentStatus } from "api/api-data-types";
import {
  ASSESSMENT_VIEW_QUERY_PARAM,
  SECONDARY_OVERLAY_QUERY_PARAM,
  SecondaryOverlay,
} from "components/constants";
import { SquareButton } from "mds/components/buttons/SquareButton";

interface StatusCellProps {
  row: MappedAllAssessmentTableRow;
  sectionId: string;
  isArchived: boolean;
}

export const StatusCell: FC<StatusCellProps> = ({ row, sectionId, isArchived }) => {
  const isNotAssessable = !row.status || row.status === AssessmentStatus.NOT_ASSESSABLE;

  if (isNotAssessable) {
    return <>-</>;
  }

  const isComplete = row.isAssessmentComplete || row.isMarkedComplete || isArchived;
  const label = getAssessmentStatusLabel({
    isMarkedComplete: row.isMarkedComplete,
    assessedSubmissionsCount: row.assessedSubmissionsCount,
    isAssessmentComplete: row.isAssessmentComplete,
    isArchived,
  });

  return (
    <SquareButton
      as={Link}
      eventName={`Course - All Assessments / ${isComplete ? "View assessed page" : "Start assessing"}`}
      eventProps={{
        pageTitle: row.title,
        pageUrl: pageUrl(sectionId, row.id),
        pageId: row.id,
      }}
      kind={isComplete ? "complete" : "accent"}
      size="xs"
      to={
        isComplete
          ? pageUrl(sectionId, row.id, {
              additionalParams: `${SECONDARY_OVERLAY_QUERY_PARAM}=${SecondaryOverlay.AssessmentSummary}`,
            })
          : pageUrl(sectionId, row.id, {
              additionalParams: `${ASSESSMENT_VIEW_QUERY_PARAM}=1`,
            })
      }
    >
      {label}
    </SquareButton>
  );
};
